import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import '../styles.less'
import MakeContractChangeWithdrawPersonPanel from '../../../widgets/makeContract/MakeContractChangeWithdrawPersonPanel'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { getMakeContractChangeWithdrawPerson } from '../../../redux/actions/contract'
import { startLoading, doneLoading } from '../../../utils/loading'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'

export default function MakeContractChangeWithdrawPerson() {
  //แก้ไขผู้ลงนามมีอำนาจลงนามเบิกจ่าย ภาคี
  const [isEditAll, setIsEditAll] = useState(false)
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [isEditWidget, setIsEditWidget] = useState({})

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getMakeContractChangeWithdrawPerson(projectVersionId)
      setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  console.log(schema)

  return (
    <>
      <SidebarProposal statusDefault={6}>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />

        {schema?.forms && (
          <>
            {schema?.forms?.agreementDetails && (
              <AgreementAdditionalWidgets
                formSchema={schema.forms.agreementDetails}
                preContentLabel={'ข้อคิดเห็นจากศูนย์สัญญา : '}
              />
            )}

            <MakeContractChangeWithdrawPersonPanel
              showCommandButton={!schema?.disabled}
              schema={schema?.forms?.forms}
              schemaFile={schema?.forms?.refFile}
              isCoworker
              id={schema?.forms?.id}
            />
            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}
